import { type FC } from 'react';
import {
  UiStack,
  UiText,
} from '@/lib/ui';
// import BaseMessageBarError from '@/base/MessageBar/Error';
// import BaseRouterLink from '@/base/Router/Link';
// import { generatePageUrl } from '@/app/pages';

export interface ApiErrorServerErrorProps {
}

const ApiErrorServerError: FC<ApiErrorServerErrorProps> = () => {
  // const loginUrl = useMemo(() => generatePageUrl('AccountLoginLoginEmail'), []);

  return (
    <UiStack>
      <UiText color={'red.500'}>Server error. Please try again.</UiText>
    </UiStack>
  );
};

export default ApiErrorServerError;
